<template>
  <div>
    <div class="inner-banner inner-bg3">
      <div class="container">
        <div class="inner-title headerTitle row">
          <div class="header_box col-lg-4 col-md-8 col-small-12">
            <p class="headerTitle_text"><span class="headerTitle_span">SIP TrunK: </span><span data-lang="menu.titleTop4"></span></p>
            <p data-lang="menu.jieshao" class="jieshao"></p>
            <div class="banner-btn header_box_btn ">
              <a @click="gotoContact" class="title_button" data-lang="foot.company.title2"></a>
              <a @click="gotoAbout" class="default-btn active fontStyle" data-lang="menu.knowMore"></a>
            </div>
          </div>
          <div class="headerTitle col-lg-6 col-md-10 col-small-12">
            <img src="/static/image/SipImg.png" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="faq-area pt-100 pb-70">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-lg-6 col-xxl-7">
            <div>
              <img src="static/image/proSip.png" alt="fAQ Images">
            </div>
          </div>
          <div class="col-lg-6 col-xxl-5">
            <div class="faq-content">
              <h2 data-lang="menu.projectList4"></h2>
              <p data-lang="menu.projectListDesc5">
              </p>
            </div>
            <div class="faq-accordion">
              <ul class="accordion">
                <li class="accordion-item">
                  <a class="accordion-title" href="javascript:void(0)">
                    <i class='bx bx-chevron-down'></i>
                    <img class="accordion-title-img" src="static/image/regist.png" alt="fAQ Images">
                    <span data-lang="product.marketing7"></span>
                  </a>
                  <div class="accordion-content">
                    <p data-lang="menu.marketDesc10">

                    </p>
                  </div>
                </li>
                <li class="accordion-item">
                  <a class="accordion-title" href="javascript:void(0)">
                    <i class='bx bx-chevron-down'></i>
                    <img class="accordion-title-img" src="static/image/yingxiao.png" alt="fAQ Images">
                    <span data-lang="product.marketing8"></span>
                  </a>
                  <div class="accordion-content">
                    <p data-lang="menu.marketDesc11">

                    </p>
                  </div>
                </li>
                <li class="accordion-item">
                  <a class="accordion-title active" href="javascript:void(0)">
                    <i class='bx bx-chevron-down'></i>
                    <img class="accordion-title-img" src="static/image/kefu.png" alt="fAQ Images">
                    <span data-lang="product.marketing9"></span>
                  </a>
                  <div class="accordion-content show">
                    <p data-lang="menu.marketDesc12">

                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="submission-area ptb-100">
      <div class="container">
        <div class="submission-title">
          <h2 data-lang="foot.form.tips"></h2>
        </div>
        <div class="submission-form">
          <div class="row formBox" id="contactForm">

            <div class="col-lg-5 col-md-6">
              <div class="form-group">
                <input data-lang="foot.form.tips" type="text" class="form-control" v-model="form.content">
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="form-group border-line">
                <input data-lang="foot.form.name" type="text" class="form-control" v-model="form.name">
              </div>
            </div>
            <div class="col-lg-5 col-md-6">
              <div class="form-group">
                <input data-lang="foot.form.phone" type="text" class="form-control" v-model="form.phone">
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="form-group border-line">
                <input data-lang="foot.form.email" type="text" class="form-control" v-model="form.email">
              </div>
            </div>

            <div class="col-lg-3 col-md-3 offset-md-5 offset-lg-0">
              <button class="default-btn" @click="submitForm">Submit</button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="price-area pt-100 pb-70">
      <div class="container">
        <div class="section-title text-center">
          <h2 data-lang="product.tip"></h2>
          <p data-lang="product.priceTip">
          </p>
        </div>
        <div class="row">
          <div class="col-lg-12 pt-45">
            <div class="tabs-item-list">
              <ul id="tabs-item" class="text-center">
                <li class="active">
                  <a @click="goToPrice" data-lang="product.seePricing" class="prices-tab"></a>
                </li>

              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  mounted() {

    this.custom()
    this.changeLang()
  },
  data() {
    return {
      form: {
        name: "",
        phone: "",
        email: "",
        content: "",
      },
      language: localStorage.getItem("language")
    }
  },

  methods: {
    submitForm() {
      if (!this.form.content) {
        let message =
          this.language == "CN" ? "请填写内容" : "Please fill in the content";
        this.$emit("msg", message, false);
      } else if (!this.form.name) {
        let message =
          this.language == "CN" ? "请填写您的姓名" : "Please fill in your name";
        this.$emit("msg", message, false);
      } else if (!this.form.phone && !this.form.email) {
        let message =
          this.language == "CN"
            ? "请填写您的联系方式"
            : "Please fill in your contact information";
        this.$emit("msg", message, false);
      } else {

        $.ajax({
          type: "POST",
          url: "https://www.yoni-tech.com/api/leave-message/add",
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify(this.form)
        });
        this.form.name = "";
        this.form.phone = "";
        this.form.email = "";
        this.form.content = "";
        let message =
          this.language == "CN"
            ? "提交成功"
            : "Submit Success";
        this.$emit(
          "msg",
          message,
          true
        );
      }
    },
    goToPrice() {
      this.$router.push('/price')
    },
    gotoContact() {
      this.$router.push('/contactUs')
    },
    gotoAbout() {
      this.$router.push('/about')
    },
  }
}
  </script>